export default __webpack_public_path__ + "static/media/rain.c665ca37.svg";